<template>
  <div class="rolesWrap">
    <el-table
      :data="tableDataInfo.result"
      style="width: 100%"
      class="rolesTable"
      border
      :max-height="listTableMaxHeight"
    >
      <el-table-column
        v-for="c in tableColumns"
        :key="c.prop"
        :label="$tt(c.label)"
        :width="$listColWidth(c)"
        :min-width="$listColMinWidth(c)"
        :prop="$listColProp(c)"
        :sortable="$listSortable(c)"
        :class-name="$listColClass(c)"
        :label-class-name="$listColClass(c)"
        :fixed="$listColFixed(c)"
        :show-overflow-tooltip="$listOverflow(c)"
      >
        <template slot-scope="scope">
          <span>{{ scope.row[c.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  listTableTopOffset: 268,
  data() {
    return {
      tableColumns: [
        {
          label: "角色名称",
          prop: "role_name",
        },
      ],
      tableDataInfo: {},
    };
  },
  mounted() {
    this.getTableData({});
  },
  methods: {
    getTableData() {
      this.$request.queryRoles({ page_num: 1, page_size: 8 }).then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }
        this.tableDataInfo = res.data || {};
      });
    },
  },
};
</script>

<style lang='scss'>
.rolesWrap {
  padding: 24px;
  background-color: #fff;
  .rolesTable {
    .normal {
      color: #67c23a;
    }
    .forbid {
      color: #f56c6c;
    }
  }
}
</style>